module.exports = __webpack_public_path__ + "04_short_yellow.e95d1c19.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/04_short_yellow.png
// module id = EIeT
// module chunks = 0